<template>
  <div class="page">
    <a-card title="新建自动回复规则" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item prop="name" label="规则名称">
          <a-input v-model="ruleForm.name" :maxLength="10" :disabled="groupId!=0" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item label="回复场景" prop="groupfansType1">
          <!-- <div>
            <div>按粉丝互动方式选择</div>
            <a-checkbox-group v-model="ruleForm.groupfansType1" :disabled="groupId!=0" :options="plainOptions" @change="onChange"/>
          </div> -->
          <div>
            <div>按粉丝互动方式选择</div>
            <a-checkbox :indeterminate="indeterminate" :disabled="groupId!=0" :checked="checkAll"
                        @change="onCheckAllChange">全部
            </a-checkbox>
            <a-checkbox-group v-model="ruleForm.groupfansType1" :disabled="groupId!=0" :options="plainOptions"
                              @change="onChange"/>
          </div>
        </a-form-model-item>
        <a-form-model-item label="定时发送" required style="margin-bottom:0;">
          <a-col :span="4">粉丝互动动作发生后</a-col>
          <a-col :span="4">
            <a-form-model-item prop="minute">
              <a-input v-model="ruleForm.minute" :disabled="groupId!=0" placeholder="请输入" suffix="分"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4" style="margin-left:10px;">
            <a-form-model-item prop="second">
              <a-input v-model="ruleForm.second" :disabled="groupId!=0" placeholder="请输入" suffix="秒"/>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item label="规则有效期" prop="sendLyTime">
          <a-range-picker name="buildTime"
                          :disabledDate="disabledDate"
                          v-model="ruleForm.sendLyTime"
                          @change="onDateChange"
                          :disabled="groupId!=0"
                          show-time
                          format="YYYY-MM-DD HH:mm:ss"/>
        </a-form-model-item>
        <a-form-model-item label="发送内容" required>
          <a-radio-group v-model="ruleForm.contentDto.sendContentType" :disabled="groupId!=0" @change="onContentChange">
            <a-radio-button :value="1">
              <a-icon type="font-size"/>
              <span>文字</span>
            </a-radio-button>
            <a-radio-button :value="2">
              <a-icon type="file-image"/>
              <span>图文</span>
            </a-radio-button>
            <a-radio-button :value="3">
              <a-icon type="picture"/>
              <span>图片</span>
            </a-radio-button>
            <!-- <a-radio-button :value="4">
              <a-icon type="unordered-list" />
              <span>菜单</span>
            </a-radio-button> -->
            <a-radio-button :value="5">
              <a-icon type="link"/>
              <span>链接</span>
            </a-radio-button>
            <a-radio-button :value="6">
              <a-icon type="dollar"/>
              <span>小程序卡片</span>
            </a-radio-button>
            <a-radio-button :value="7">
              <a-icon type="credit-card"/>
              <span>富文本</span>
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.contentDto.sendContentType==1" prop="contentDto.contentDetail" label="文字">
          <a-textarea v-model="ruleForm.contentDto.contentDetail" placeholder="请输入文字内容，不超过300个字"
                      :maxLength="300" :auto-size="{ minRows: 5, maxRows: 8 }"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="ruleForm.contentDto.sendContentType==2||ruleForm.contentDto.sendContentType==3||ruleForm.contentDto.sendContentType==6"
          label="图片" prop="contentDto.contentImgUrl">
          <div class="upload-box">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="actionImageUrl"
              @change="handleChange"
              :before-upload="beforeUploadFile"
            >
              <img v-if="ruleForm.contentDto.contentImgUrl" :src="ruleForm.contentDto.contentImgUrl" alt="avatar"
                   class="img-avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <div v-if="ruleForm.contentDto.sendContentType==2">
          <a-form-model-item prop="contentDto.contentTitle" label="标题">
            <a-input v-model="ruleForm.contentDto.contentTitle" :maxLength="32" placeholder="请输入"/>
          </a-form-model-item>
          <a-form-model-item prop="contentDto.contentDetail" label="描述">
            <a-textarea v-model="ruleForm.contentDto.contentDetail" placeholder="请输入" :maxLength="150"
                        :auto-size="{ minRows: 5, maxRows: 8 }"/>
          </a-form-model-item>
          <a-form-model-item prop="contentDto.contentLink" label="链接">
            <a-input v-model="ruleForm.contentDto.contentLink" :maxLength="100" placeholder="请输入"/>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.contentDto.sendContentType==4">
          <div v-for="(item, index) in ruleForm.contentDto.menuList" :key="index">
            <a-form-model-item
              :wrapper-col="index === 0 ? currentFormLayout.wrapperCol : currentFormLayout.offsetCol"
              :label="index === 0 ? '菜单描述' : ''"
              :prop="'contentDto.menuList.' + index + '.contentDetail'"
              :rules="{ required: true, message: '请输入菜单', trigger: 'blur',}"
            >
              <a-input v-model="item.contentDetail" placeholder="请输入菜单描述"/>
            </a-form-model-item>
            <a-form-model-item
              :wrapper-col="index === 0 ? currentFormLayout.wrapperCol : currentFormLayout.offsetCol"
              :label="index === 0 ? '菜单地址' : ''"
              :prop="'contentDto.menuList.' + index + '.contentLink'"
              :rules="{ required: true, message: '请输入菜单地址', trigger: 'blur',}"
            >
              <a-input v-model="item.contentLink" placeholder="请输入菜单地址"/>
              <a-icon
                v-if="ruleForm.contentDto.menuList.length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :style="{fontSize:'20px',marginLeft:'5px'}"
                :disabled="ruleForm.contentDto.menuList.length === 1"
                @click="removeDomain(item)"
              />
            </a-form-model-item>
          </div>
          <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
            <a-button type="dashed" @click="addDomain" style="width:568px;">
              <a-icon type="plus"/>
              添加
            </a-button>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.contentDto.sendContentType==5">
          <a-form-model-item prop="contentDto.contentTitle" label="标题">
            <a-input v-model="ruleForm.contentDto.contentTitle" :maxLength="30" placeholder="请输入"/>
          </a-form-model-item>
          <a-form-model-item prop="contentDto.contentLink" label="链接">
            <a-input v-model="ruleForm.contentDto.contentLink" :maxLength="100" placeholder="请输入"/>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.contentDto.sendContentType==6">
          <a-form-model-item prop="contentDto.contentTitle" label="卡片标题">
            <a-input v-model="ruleForm.contentDto.contentTitle" :maxLength="12" placeholder="请输入"/>
          </a-form-model-item>
          <a-form-model-item prop="contentDto.contentAppletLink" label="小程序路径">
            <a-input v-model="ruleForm.contentDto.contentAppletLink" :maxLength="100" placeholder="请输入"/>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.contentDto.sendContentType==7">
          <a-form-model-item label="富文本" prop="sendRichText">
            <div class="a-btns">
              <a @click="insertData(3)">插入文字</a>
              <a @click="insertData(1)">插入链接</a>
              <a @click="insertData(2)">插入小程序路径</a>
              <a @click="deleteData">清空</a>
            </div>
            <a-textarea v-model="ruleForm.sendRichText" disabled placeholder="请输入" :maxLength="350"
                        :auto-size="{ minRows: 5, maxRows: 8 }"/>
          </a-form-model-item>
        </div>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button v-if="groupId==0" type="primary" @click="handleSubmit('ruleForm')" :loading="submitLoading">提 交
          </a-button>
          <a-button v-if="groupId!=0&&status==1" @click="showConfirm">提前结束</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-modal :title="modalTitle" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="dialogForm" ref="dialogForm" :rules="dialogRules"
                    :label-col="currentDialogFormLayout.labelCol"
                    :wrapper-col="currentDialogFormLayout.wrapperCol"
      >
        <div v-if="modalType==1">
          <a-form-model-item label="链接标题" prop="linkTitle">
            <a-input placeholder="请输入" v-model="dialogForm.linkTitle" :maxLength="10"/>
          </a-form-model-item>
          <a-form-model-item label="链接地址" prop="linkUrl">
            <a-input placeholder="http://或https://开头" v-model="dialogForm.linkUrl" :maxLength="100"/>
          </a-form-model-item>
        </div>
        <div v-else-if="modalType==2">
          <a-form-model-item label="小程序AppId" prop="appletAppId">
            <a-input placeholder="请输入路径名称" v-model="dialogForm.appletAppId" :maxLength="20"/>
          </a-form-model-item>
          <a-form-model-item label="小程序路径名称" prop="appletName">
            <a-input placeholder="请输入路径名称" v-model="dialogForm.appletName" :maxLength="10"/>
          </a-form-model-item>
          <a-form-model-item label="小程序路径地址" prop="appletPathUrl">
            <a-input placeholder="请输入路径地址" v-model="dialogForm.appletPathUrl" :maxLength="100"/>
          </a-form-model-item>
        </div>
        <div v-else>
          <a-form-model-item label="文字" prop="text">
            <a-textarea v-model="dialogForm.text" placeholder="请输入" :maxLength="350"
                        :auto-size="{ minRows: 3, maxRows: 5 }"/>
          </a-form-model-item>
        </div>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit('dialogForm')" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import moment from 'moment'

export default {
  name: 'GroupSentMessage',
  mixins: [ruleFormMixins],
  data() {
    let validateMinute = (rule, value, callback) => {
      if (value > 5) {
        callback(new Error('0-5分钟'))
      } else {
        callback()
      }
    }
    let validateSecond = (rule, value, callback) => {
      if (value > 59) {
        callback(new Error('0-59秒'))
      } else {
        callback()
      }
    }
    return {
      moment,
      groupId: this.$route.query.groupId ? this.$route.query.groupId : 0,
      status: this.$route.query.status ? this.$route.query.status : 0,
      submitLoading: false,
      dialogVisible: false,
      modalTitle: '',
      modalType: 0,
      currentDialogFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      plainOptions: [],
      indeterminate: false,
      checkAll: true,
      checkedIdList: [],
      ruleForm: {
        sendRichText: '',//(前端加的，保存时删除）
        contentDto: {
          contentDetail: '',//文本或富文本或者描述 ,
          contentImgUrl: '',//图片
          contentLink: '',//链接或小程序路径或菜单链接 ,
          contentTitle: '',//标题
          contentAppletLink: '',//小程序路径（前端加的，保存时删除）
          menuList: [
            {
              contentDetail: '',//菜单描述
              contentLink: ''//菜单链接
            }
          ],
          sendContentType: 1//发送内容类型 1文字、2图片、3图文、4菜单、5链接、6小程序卡片、7富文本
        },
        id: 0,//自动Id ,
        merchantId: this.$store.getters.userInfo.merchantId,//运营商ID
        name: '',//自动名称 ,
        platformId: this.getPlatformConfig().platformId,//平台
        groupfansType1: ['0'],//(前端加的，保存时删除)
        replyScene: 0,//回复场景-按粉丝互动方式选择 0:全部 1：关注，2：扫码 3：发送消息 4:点击菜单 逗号隔开
        sendLyTime: undefined,//前端加的，保存时删除
        sendTime: '',//发送时间HH:ss:mm ,
        sendTypeApp: 0,//发送对象-按公众号用户标签选择 0:全部 动态 逗号隔开
        sendTypeBackground: 0,// 送对象-按后台用户标签选择 0:全部 动态 逗号隔开
        ruleValidityEndTime: '',
        ruleValidityStartTime: '',
        minute: '',//前端加的，保存时删除
        second: ''//前端加的，保存时删除
      },
      dialogForm: {
        linkTitle: '',
        linkUrl: '',
        appletAppId: '',
        appletName: '',
        appletPathUrl: '',
        text: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        groupfansType1: [
          { required: true, message: '请选择回复场景', trigger: 'change' }
        ],
        sendLyTime: [
          { required: true, message: '请选择规则有效期', trigger: 'change' }
        ],
        minute: [
          { required: true, message: '请输入分钟', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur' },
          { validator: validateMinute, trigger: 'blur' }
        ],
        second: [
          { required: true, message: '请输入秒', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur' },
          { validator: validateSecond, trigger: 'blur' }
        ],
        'contentDto.contentImgUrl': [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        'contentDto.contentDetail': [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        'contentDto.contentTitle': [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        'contentDto.contentLink': [
          { required: true, message: '请输入链接', trigger: 'blur' },
          { pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确链接' }
        ],
        contentAppletLink: [
          { required: true, message: '请输入小程序地址', trigger: 'blur' }
        ],
        sendRichText: [
          { required: true, message: '请输入富文本内容', trigger: 'blur' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      dialogRules: {
        linkTitle: [
          { required: true, message: '请输入链接标题', trigger: 'blur' }
        ],
        linkUrl: [
          { required: true, message: '请输入链接地址', trigger: 'blur' },
          { pattern: /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/, message: '请输入正确链接' }
        ],
        appletAppId: [
          { required: true, message: '请输入小程序appId', trigger: 'blur' }
        ],
        appletName: [
          { required: true, message: '请输入小程序路径名称', trigger: 'blur' }
        ],
        appletPathUrl: [
          { required: true, message: '请输入小程序路径地址', trigger: 'blur' }
        ],
        text: [
          { required: true, message: '请输入文字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupSentMessage', title: '群发消息' },
      { name: 'GroupSendList', title: '群发记录' },
      { name: 'AutoReplyList', title: '自动回复' }
    ])
    this.getLogUtils().logWithTag('groupId：', this.groupId)
    this.getBatchReplySceneEnum()
    this.getMsgBatchDetail()
  },
  methods: {
    getBatchReplySceneEnum() {
      this.getHttpServices().getServerApiService().post('wxMsg/v2/getReplySceneEnum').then(res => {
        this.plainOptions = res
        if (res && res.length > 0) {
          let arr = []
          let arrObj = []
          res.forEach(item => {
            if (item.value != 0) {
              arrObj.push(item)
              arr.push(item.value)
            }
          })
          this.plainOptions = arrObj
          this.ruleForm.groupfansType1 = arr
          this.checkedIdList = arr
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.dialogVisible = false
    },
    removeDomain(item) {
      let index = this.ruleForm.contentDto.menuList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.contentDto.menuList.splice(index, 1)
      }
    },
    addDomain() {
      if (this.ruleForm.contentDto.menuList.length < 8) {
        this.ruleForm.contentDto.menuList.push({
          contentDetail: '',
          contentLink: ''
        })
      } else {
        this.$message.error('菜单最多支持8个')
      }
    },
    //可用日期
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.ruleForm.sendLyTime = dates
      this.ruleForm.ruleValidityStartTime = dateStrArr[0]
      this.ruleForm.ruleValidityEndTime = dateStrArr[1]
    },
    // onChange(checkedValues) {
    //   this.getLogUtils().logWithTag("checked===",checkedValues)
    //   let str = checkedValues.join(",");
    //   this.ruleForm.replyScene = str;
    //   this.getLogUtils().logWithTag("checked===",this.ruleForm.replyScene)
    // },
    onChange(checkedList) {
      this.getLogUtils().logWithTag('onChange===', checkedList)
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onCheckAllChange(e) {
      this.getLogUtils().logWithTag('onCheckAllChange===', e)
      // Object.assign(this, {
      //   checkedList: e.target.checked ? this.checkedIdList : [],
      //   indeterminate: false,
      //   checkAll: e.target.checked,
      // });
      this.ruleForm.groupfansType1 = e.target.checked ? this.checkedIdList : []
      this.checkAll = e.target.checked
      this.indeterminate = false
      this.getLogUtils().logWithTag('数据===', this.ruleForm.groupfansType1)
    },
    onContentChange(e) {
      this.getLogUtils().logWithTag('checked===', e.target.value)
      this.ruleForm.contentDto.sendContentType = e.target.value
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.contentDto.contentImgUrl = url
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    handleSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (form == 'ruleForm') {
            this.submitData()
          } else {
            this.saveData()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.replyScene = this.submitFormData.groupfansType1.join(',')
      this.getLogUtils().logWithTag('submitFormData', this.submitFormData)
      this.submitFormData.sendTime = '00:' + this.submitFormData.minute + ':' + this.submitFormData.second
      if (this.submitFormData.contentDto.sendContentType == 6) {
        this.submitFormData.contentDto.contentLink = this.submitFormData.contentDto.contentAppletLink
      }
      delete this.submitFormData.groupfansType1
      delete this.submitFormData.sendRichText
      delete this.submitFormData.sendLyTime
      delete this.submitFormData.contentDto.contentAppletLink
      this.getLogUtils().logWithTag('submitFormData删除后', this.submitFormData)
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('wxMsg/v2/saveWxMsgAutomatic', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('自动回复规则保存成功')
        setTimeout(() => {
          this.$router.push({
            name: 'AutoReplyList',
            query: {
              serverId: this.$route.query.serverId,
              serverUniqueId: this.$route.query.serverUniqueId
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    saveData() {
      let str = ''
      let replaceStr = ''
      let textStr = ''
      if (this.modalType == 1) {
        str = '<a href=\'' + this.dialogForm.linkUrl + '\'>' + this.dialogForm.linkTitle + '</a>'
        replaceStr = str.replace(/<a.*?>/gi, '{').replace(/<\/a>/gi, '}')
      } else if (this.modalType == 2) {
        str = '<a href=\'\' data-miniprogram-appid=\'' + this.dialogForm.appletAppId + '\' data-miniprogram-path=\'' + this.dialogForm.appletPathUrl + '\'>' + this.dialogForm.appletName + '</a>'
        replaceStr = str.replace(/<a.*?>/gi, '{').replace(/<\/a>/gi, '}')
      } else {
        textStr = this.dialogForm.text
      }
      this.ruleForm.contentDto.contentDetail = this.ruleForm.contentDto.contentDetail + str + textStr
      this.ruleForm.sendRichText = this.ruleForm.sendRichText + replaceStr + textStr
      this.getLogUtils().logWithTag('sendRichText', this.ruleForm.sendRichText)
      this.getLogUtils().logWithTag('contentDetail', this.ruleForm.contentDto.contentDetail)
      this.dialogVisible = false
    },
    deleteData() {
      this.ruleForm.contentDto.contentDetail = ''
      this.ruleForm.sendRichText = ''
    },
    // 插入链接/小程序
    insertData(type) {
      if (type == 1) {
        this.modalTitle = '插入链接'
        this.dialogForm.text = ''
        this.dialogForm.appletAppId = ''
        this.dialogForm.appletName = ''
        this.dialogForm.appletPathUrl = ''
      } else if (type == 2) {
        this.dialogForm.text = ''
        this.dialogForm.linkTitle = ''
        this.dialogForm.linkUrl = ''
        this.modalTitle = '插入小程序路径'
      } else {
        this.dialogForm.appletAppId = ''
        this.dialogForm.appletName = ''
        this.dialogForm.appletPathUrl = ''
        this.dialogForm.linkTitle = ''
        this.dialogForm.linkUrl = ''
        this.modalTitle = '插入小程序文字'
      }
      this.modalType = type
      this.dialogVisible = true
    },
    // 查询详情
    getMsgBatchDetail() {
      if (this.groupId != 0) {
        this.getHttpServices().getServerApiService().post('wxMsg/v2/wxMsgAutomaticDetail', {
          id: this.groupId,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          this.getLogUtils().logWithTag('submitData', res)
          this.ruleForm = res
          if (this.ruleForm.replyScene) {
            this.ruleForm.groupfansType1 = this.ruleForm.replyScene.split(',')
            if (this.ruleForm.groupfansType1.length == this.plainOptions.length) {
              this.indeterminate = false
              this.checkAll = true
            } else {
              this.indeterminate = true
              this.checkAll = false
            }
          }
          if (this.ruleForm.sendTime) {
            let arr = this.ruleForm.sendTime.split(':')
            this.getLogUtils().logWithTag('arr', arr)
            this.ruleForm.minute = arr[1]
            this.ruleForm.second = arr[2]
          }
          if (this.ruleForm.ruleValidityEndTime) {
            this.ruleForm.sendLyTime = this.getDateHelper().getDateMoments(res.ruleValidityStartTime, res.ruleValidityEndTime)
          }
          if (this.ruleForm.contentDto.sendContentType == 6) {
            this.ruleForm.contentDto.contentAppletLink = this.ruleForm.contentDto.contentLink
          }
          if (this.ruleForm.contentDto.sendContentType == 7) {
            this.ruleForm.sendRichText = this.ruleForm.contentDto.contentDetail.replace(/<a.*?>/gi, '{').replace(/<\/a>/gi, '}')
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    },
    // 提前结束功能
    showConfirm() {
      let that = this
      this.$confirm({
        title: '此操作将提前结束该功能?，是否继续',
        onOk() {
          that.overbtn()
        },
        onCancel() {
          that.$message.info('已取消')
        }
      })
    },
    // 提前结束
    overbtn() {
      this.getHttpServices().getServerApiService().post('wxMsg/v2/wxMsgClose', {
        id: this.groupId,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('自动回复规则提前结束成功')
        setTimeout(() => {
          this.$router.push({
            name: 'AutoReplyList',
            query: {
              serverId: this.$route.query.serverId,
              serverUniqueId: this.$route.query.serverUniqueId
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.img-avatar {
  width: 100px;
  height: 100px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.upload-box {
  .avatar-uploader > .ant-upload {
    width: 100px;
    height: 100px;
  }
}

input, textarea {
  max-width: 568px;
}

.fu-text {
  height: 115px;
  min-height: 115px;
  max-height: 178px;
  overflow-y: hidden;
  border: 1px solid #d9d9d9;
  max-width: 568px;
  padding: 4px 11px;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 20px;

  &:focus {
    outline: none;
  }
}

.a-btns {
  margin-bottom: 5px;

  a + a {
    margin-left: 10px;
  }
}

.w150 {
  width: 150px;
  display: inline-block;
}
</style>